import React from 'react'
import './header.css'
import { Movie } from '@material-ui/icons'

const Header = () => {
  return (
    <div className='header' onClick={() => window.scroll(0,0)}>
      <Movie /> <h2 className='webname'>Movies Hub</h2> <Movie />
    </div>
  )
}

export default Header
